<template>
    <div>
    <!--- Nav Bar main -->
    <nav-bar-main></nav-bar-main>

    <nav-bar-dispositivi  v-if="plantDetails != null" class="animated fadeIn container-fluid"></nav-bar-dispositivi>
 
        <div v-if="plantDetails != null"  class="animated fadeIn container-fluid">
            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
                <div>
                
                <!-- navbar dei comandi visibile solo se admin o installatore o collaboratore -->
                <b-row v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab' ||  this.$store.state.user.usertype=='admin'" class="fixed-top navbar-command">
                    <b-col lg="12" md="12">

                    <!-- banner error on plant -->
                    <div v-if="error != null" class="alert alert-danger" role="alert">
                        {{$t(error)}}
                    </div>

                    <!-- banner per basic plant -->
                    <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro/>
                    </b-alert>
                    
                    <!-- banner per pro expired -->
                    <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro-expired/>
                    </b-alert>
                
                    <!--- Loader per il caricamento pagina o invio dei comandi -->
                    <Loader/>
                    

                    <!-- barra dei comandi -->
                    <b-row v-if="!$store.state.loading" class="pull-left ml-4" style="width: 100%">
                            <b-button class="typo-butt-add mt-3 mr-1 but-add" @click="openScanQr">
                                <i class="fas fa fa-2x fa-qrcode mr-2"></i> {{$t("qrlamps.btn_scan")}}
                            </b-button>                    
                            <div id="navbar-search">
                                <div id="navbar-filter" v-if="!advancedFilters">     
                                        <b-input-group>
                                            <b-form-input type="text" placeholder="Cerca" v-model="filters.search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtra()"><i class="fa fa-search"></i> </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                </div>
                            </div>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </show-at>

            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
                <div>
                    <b-nav class="mobile-sub-nav fixed-top">
                        <!--<b-button size="sm" v-b-toggle.commands-collapse>+</b-button>-->
                        <b-nav-text style="padding-left:16px"> {{$t("navbar_dispositivi.button_centrali")}}</b-nav-text>
                        <!--<b-dropdown id="dd-centrali-menu" right no-caret >
                            <template v-slot:button-content>
                            <i class="fa fa-bars fa-lg"></i>
                            </template>
                            <b-dropdown-item class="active">{{$t("navbar_dispositivi.button_centrali")}}</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantgeneral/'+ this.$store.state.currentPlant.id}" >{{$t("navbar.settings_generali")}}</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantusers/'+ this.$store.state.currentPlant.id}">{{$t("navbar.settings_utenti")}}</b-dropdown-item>
                        </b-dropdown>-->
                    </b-nav>
                </div>
            </show-at>

             <!-- Tabella collections -->
            <div v-if="tableData" style="margin-top:125px">
           
            <b-list-group v-for="item in tableData" v-bind:key="item.collectionId">
              <b-list-group-item class="mb-2 mt-1"> 
                <b-row>
                    <b-col cols="11">
                        <h5 class="mb-2 ml-1">{{item.collectionName}}</h5>
                    </b-col>
                    <b-col cols="1">
                        <b-row>
                            <b-button><i class="fas fa-trash-alt" style="color:#0090CD" @click="removeCollection(item)"></i></b-button>
                            <edit-collection :collection="item"> </edit-collection>
                        </b-row>
                    </b-col>        
                </b-row>
                <small>{{item.collectionType.toUpperCase()}}</small>
              </b-list-group-item>
            </b-list-group>

            </div>


        </div>

    </div>    

</template>

<script>

import Vue from 'vue'
import {ClientTable, Event} from 'vue-tables-2'
Vue.use(ClientTable)

import NavBarMain from '@/components/NavBarMain'
import NavBarDispositivi from '@/components/NavBarDispositivi'
import AddCollection from '@/components/AddCollection'
import EditCollection from '@/components/EditCollection'
import CreaAggregazione from '@/components/CreaAggregazione'
import {showAt, hideAt} from 'vue-breakpoints'
import BannerPro from '@/components/BannerPro'
import BannerProExpired from '@/components/BannerProExpired'

import { mapState } from 'vuex';


export default {
    name: 'DispositiviImpianto',
    components: {
        NavBarMain,
        NavBarDispositivi,
        AddCollection,
        EditCollection,
        CreaAggregazione,
        BannerPro,
        BannerProExpired,
        Event,
        hideAt, 
        showAt 
    },
    props: ['plantId'],
    data() {
        return {
            cuToRemove: null,
            modalRemoveCuVisible: false,
            cuGroups:null,
            cuAdvanced:null,
            modalGroupsCuVisible:false,
            modalAdvancedCuVisible:false,
            advancedFilters: false,
            filters: {
                search: '',
                idCent: '',
                nomeCent: '',
                idLamp: '',
                nomeLamp: '',
                tipoCent: ['all'],
                tipoLamp: 'all',
                autonomia: ['all'],
                parita: 'all',
                infinity: 'all',
                rete_se:'all'
            },
            selectedGroup: '',
            groups: Array.from([,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]),
            alerts: [],
            validation_alerts: [],
            currentCent: null,
            currentLamp: null,
            status: 'none_selected',
            headerClose: true,
            
            loop: 0,
        }     
    
    },

    computed: {
        ...mapState(['loading','error','commandsPending', 'commandResponse']),
      
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null)  {
                this.tableData = [];
                return null;
            }
            if (plant.id != this.plantId) return null;
            return plant;
        },
        collectionDetails(){
            this.tableData=this.$store.state.plantCollections;
            console.log("Collections: ",this.tableData);
            return this.tableData;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        allTableData() {
            return this.$store.state.plantUnits || [];
        }, 
        numUnits() {
            if (this.unitsDetails == null || this.unitsDetails.length == 0)  return 0;
            return this.unitsDetails.length;
        },
        totalLamps() {


            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0
            return this.unitsDetails.reduce(function(total,u){
                //return total + ((u.lamps_id == null) ? 0 : u.lamps_id.length);
                if(u.cu_type=="cablecom")
                    return total + (u.num_lamp_found | 0);
                else
                    return total + (u.num_lamp_present | 0);
            },0); 
            
        },
    },
    mounted() {
        console.log("mounted",this.plantDetails);
                      
    },
    updated() {
        
    },
    watch: {
        loading(val,oldval) {
            console.log("qrlamps loading changed:" + val+", error=" + this.error+", loop=" + this.loop);
            //if (this.loop > 50) return;
            
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
            console.log("Ruolo utente", this.$store.state.user.usertype);
        },
        commandResponse(val, oldval) {
            console.log("cambiata commandResponse ->", val);
            let resp = val; 
            console.log("analizzo la risposta, loop= " + this.loop  , resp);
            if (!resp.pending && resp.command != null) {
                    if (resp.error != null && resp.error != "") {
                        console.log("resp error",resp.error);
                        var alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: "Resp error"
                        }  
                        this.alerts.push(alert);  
                    } else {
                        console.log("risposta ok per comando " + resp.command + ", cu:" + resp.cu);
                        switch (resp.command) {
                                case 'saveCollection':
                                     this.$store.dispatch('loadPlantCollections', this.plantId);  
                                    break;
                                case 'updateCollection': 
                                    //let coll = this.tableData.filter(coll => coll.collectionId == resp.response.collectionInfo.collectionId);
                                    //if (coll != null) coll.
                                    for (var i=0; i< this.tableData.length; i++) {
                                        var coll = this.tableData[i];
                                        if (coll.collectionId == resp.response.collectionInfo.collectionId) {
                                            this.tableData[i] = resp.response.collectionInfo;
                                            //console.log("aggiornata collection");
                                            
                                            this.$forceUpdate();
                                            break;
                                        }
                                    }
                                    break;
                                case 'removeCollection':
                                    for (var i=0; i< this.tableData.length; i++) {
                                        var coll = this.tableData[i];
                                        if (coll.collectionId == resp.response.collectionInfo.collectionId) {
                                            this.tableData.splice(i,1);
                                            this.$forceUpdate();
                                            break;
                                        }
                                    }
                                    break;
                            }
                        }

                    }
        }
    },
    methods: {
        
        filtra() {
            let self = this;
            

        },
        
        
        onDecode(decodedString) {
            console.log("codeScanned:",decodedString);
            this.qrScanned = decodedString;
          //setTimeout(function() {
            this.scanning = false;
          //},2000);
          
        },
      
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) return user[0].role;
            return "?";
        },
        passaAPro() {
             this.$router.push({
                name: "GeneraliImpianto",
                params: { plantId: this.$store.state.currentPlant.id }
            });
        },
        
       
       
    }
}
</script>